import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import minMax from 'dayjs/plugin/minMax';
import 'dayjs/locale/ar'; // Import Arabic locale

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(minMax);
dayjs.locale('ar'); // Set default locale to Arabic


@Pipe({
  name: 'sinceDate',
  standalone: true
})
export class SinceDatePipe implements PipeTransform {

  transform(startTimestamp: any): unknown {
    // الحصول على timezone المتصفح/الجهاز تلقائياً
    let time_zone: string;
    try {
      // محاولة الحصول على timezone من المتصفح
      time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      // في حالة الفشل، استخدام timezone افتراضي
      time_zone = 'Asia/Cairo'; // مصر كافتراضي
    }
    
    // Parse the notification time correctly
    let notificationTime;
    
    if (!startTimestamp) {
      // Fallback to current time if timestamp is invalid
      notificationTime = dayjs().tz(time_zone);
    } else if (typeof startTimestamp === 'number') {
      // Unix timestamp in milliseconds - JavaScript timestamps are UTC
      // Use utc() to ensure correct interpretation, then convert to local timezone
      notificationTime = dayjs.utc(startTimestamp).tz(time_zone);
    } else if (typeof startTimestamp === 'string') {
      // String timestamp from API - could be ISO format or other
      // Try to parse as UTC first (API usually sends UTC), then convert to local timezone
      const parsed = dayjs.utc(startTimestamp);
      if (parsed.isValid()) {
        notificationTime = parsed.tz(time_zone);
      } else {
        // If UTC parsing fails, try local parsing
        notificationTime = dayjs(startTimestamp).tz(time_zone);
      }
    } else {
      // For Date objects or other types
      notificationTime = dayjs(startTimestamp).tz(time_zone);
    }

    // Ensure we have a valid time
    if (!notificationTime || !notificationTime.isValid()) {
      notificationTime = dayjs().tz(time_zone);
    }

    const currentTime = dayjs().tz(time_zone);
    const timeFormat = 'hh:mm A'; // 02:30 م
    
    // Check if it's today
    if (notificationTime.isSame(currentTime, 'day')) {
      return `اليوم، ${notificationTime.format(timeFormat)}`;
    }
    
    // Check if it's yesterday
    if (notificationTime.isSame(currentTime.subtract(1, 'day'), 'day')) {
      return `أمس، ${notificationTime.format(timeFormat)}`;
    }
    
    // For other dates, show full date and time
    // Example: 28 أكتوبر 2024، 02:30 م
    return notificationTime.format('D MMMM YYYY، hh:mm A');
  }
};
